<template>
  <v-footer
    class="pa-0 transparent"
    :style="$attrs.style">
    <v-row class="d-flex justify-end" no-gutters>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="3"
        :style="columnStyle"
        class="d-flex justify-end">
        <v-btn
          outlined
          :color="defaultColor"
          width="100%"
          @click="backToHomeAllMenus()"
          :style="btnStyle">
          Voltar
        </v-btn>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';

export default {
  name: "DefaultFooter",

  data: () => ({
    isRHProtegido: false,
  }),

  props: {
    defaultColor: {
      type: String,
      required: false,
      default: "primary",
    },

    btnStyle: {
      type: String,
      required: false,
      default: "height: 57px;",
    },

    columnStyle: {
      type: String,
      required: false,
      default: "max-width: 300px;",
    },

    defaultRoute: {
      type: String,
      default: 'HomeAllMenus',
    }
  },

  mixins: [
    VerifyRoutesMixin,
  ],

  methods: {
    backToHomeAllMenus() {
      this.redirectRouter(this.defaultRoute, { isRHProtegido: this.isRHProtegido });
    }
  },

  created() {
    this.isRHProtegido = this.$route.query.isRHProtegido;
  },
}
</script>